import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="time-blocks" — dynamically add/remove nested
// TimeBlock fieldsets (a start/end time pair) using Rails' standard nested-
// attributes template pattern: #add clones the blank template with a fresh
// index, #remove either drops the DOM node (a block that was never saved)
// or marks it _destroy=1 and hides it (a persisted block, so Rails still
// deletes the record on submit). Mirrors the mockup's "+ Add time block".
export default class extends Controller {
  static targets = [ "list", "template", "block" ]
  // Text comes in from the view rather than living here, so the label stays in
  // the locale files with every other string.
  static values = { blockLabel: String }

  connect() {
    this.renumber()
  }

  add() {
    const index = new Date().getTime()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, index)
    this.listTarget.insertAdjacentHTML("beforeend", html)
    this.renumber()
    this.dispatchChanged()
    this.reveal(this.listTarget.lastElementChild)
  }

  // Zonder dit gebeurt er zichtbaar niets: het nieuwe tijdvak komt onder de
  // rand van het scherm te staan. Het scherm schuift ernaartoe en de begintijd
  // krijgt de aandacht, zodat je meteen kunt typen.
  reveal(block) {
    if (!block) return

    const smooth = !window.matchMedia("(prefers-reduced-motion: reduce)").matches
    block.scrollIntoView({ behavior: smooth ? "smooth" : "auto", block: "center" })
    block.querySelector("input:not([type='hidden'])")?.focus({ preventScroll: true })
  }

  remove(event) {
    const block = event.target.closest("[data-time-blocks-target='block']")
    const destroyField = block.querySelector("input[name$='[_destroy]']")
    const idField = block.querySelector("input[name$='[id]']")

    if (idField && idField.value) {
      destroyField.value = "1"
      block.hidden = true
    } else {
      block.remove()
    }

    this.renumber()
    this.dispatchChanged()
  }

  renumber() {
    const visible = this.blockTargets.filter((block) => !block.hidden)

    visible.forEach((block, index) => {
      block.querySelector(".time-block-label").textContent = `${this.blockLabelValue} ${index + 1}`
      block.querySelector(".time-block-remove").hidden = visible.length <= 1
    })
  }

  // Newly inserted fields aren't wired to anything yet (a fresh clone has no
  // values), but the break preview still needs to recompute since the
  // overall block count/shape changed.
  dispatchChanged() {
    this.element.dispatchEvent(new Event("time-blocks:changed", { bubbles: true }))
  }
}
